/* eslint-disable max-len */
/* eslint-disable @typescript-eslint/naming-convention */
import { Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, OnDestroy } from '@angular/core';
import { HotToastService } from '@ngneat/hot-toast';
import { DataCollectorService } from 'app/core/services/data_collector_services/data_collector_service.service';
import { DataPickerService } from 'app/core/services/data_picker/data_picker.service';
import { LocalStorageService } from 'app/core/services/localstorage.service';
import { UtilityService } from 'app/core/services/utility_functions/utility_functions.service';
import { MapsService } from 'app/modules/maps/maps.service';
import { Subscription } from 'rxjs';
import { PickerOptions, PickerSelectDisableOptions, PickerSelectOptions } from '../data-picker/data-picker.interface';
import { JobsService } from 'app/core/services/jobs/jobs.service';
import moment from 'moment';
import { ZuperDialogService } from '@zuper/components/zuper-dialog/zuper-dialog.service';
import { RemoveJobComponent } from '../remove-job/remove-job.component';
import { ZuperDrawerService } from '@zuper/components/zuper-drawer';
import { MatDialogRef } from '@angular/material/dialog';
import { DispatchBoardService } from '../../../../projects/dispatch-board/src/app/components/dispatch-board/dispatch-board.service';
import _ from 'lodash';

@Component({
  selector: 'app-route-details',
  templateUrl: './route-details.component.html',
  styleUrls: ['./route-details.component.scss']
})
export class RouteDetailsComponent implements OnInit, OnChanges, OnDestroy {

  @Input() data: any;
  @Input() openPicker: boolean;
  @Input() parentModule: string;
  @Output() actionComplete: EventEmitter<any> = new EventEmitter();

  currentTab = 'PRIMARY';
  dateFormat: string;
  dateTimeFormat: string;

  transportModeObj = {
    'CAR': 'route.choose_mode_of_transport.car_semi_truck',
    'TRUCK': 'route.choose_mode_of_transport.truck',
    'PEDESTRIAN': 'route.choose_mode_of_transport.pedestrian'
  };

  routeOptimisationObj = {
    'FASTEST': 'route.fastest_travel_time',
    'SHORTEST': 'route.shortest_distance'
  };

  currentRoute: any = null;
  totalJobDuration: number = 0;
  companyConfig: any;

   //Employee Assignment
   assignEmployeeOptions: any = {
      details: {
        'assigned_to': []
      },
      hideNotify: true
    };
   openEmployee: boolean = false;
   openForm: boolean;
   routeEditFormOption = {
    state: 'edit',
    header: 'route.edit'
  };

  //Reorder Jobs
  openReorder: boolean = false;
  jobs: any;

  //Add Job
  openJob: boolean = false;
  jobPickerSubscription: Subscription;
  jobPickerOptions: PickerOptions = {
    header: {
      displayKey: null,
      displayName: this.utilityService.getLocaleValue('route.add.job')
    },
    position: 'right',
    mode: 'over',
    hasBackDrop: false,
    allowQuickCreate: false,
    showListCount: true,
    customParams: {
      'filter.is_recurrence': false
    },
    dataConfig: { routeJobFromRouteWarning: true },
    selectOption: PickerSelectOptions.multiSelect,
    selectionDisableBasedOn: PickerSelectDisableOptions.GEOLOCATION,
    filters: {
      enableAssignmentStatus: true,
      enableAssignEmployee: true,
      enableCategory: true, 
      dateRange: {
        enabled: true
      }
    }
  };

  //Assign to route
  showAssignRoute: boolean = false;
  currentRouteDate: any = moment();
  currentSelectedJob: any;

  //Job Preview
  previewOptions: any = {
    position: 'right',
    type: 'summary',
    mode: 'over',
    hasBackDrop: false,
    menuOptions: {
      viewDetails: true,
      delete: false,
      clone: false
    }
  };
  openJobPreview: boolean = false;
  currentJob: any;
  timezone: any;

  sequencedJobs: any[] = [];

  constructor(
    private _mapService: MapsService,
    private _dataCollectorService: DataCollectorService,
    private _toast: HotToastService,
    private _zuperDrawerService: ZuperDrawerService,
    private _localStorageService: LocalStorageService,
    private _datapickerService: DataPickerService,
    public _dispatchBoardService: DispatchBoardService,
    private _jobsService: JobsService,
    private _zuperDialogService: ZuperDialogService,
    public utilityService: UtilityService
  ) { }

  previewDataEventHandler(event: any): void {
    if(event?.drawerClosed){
      this.openJobPreview = false;
    }
  }

  openJobDetail(job: any): void {
    this.currentJob = job;
    this.openJobPreview = true;
  }

  toggleDrawer(drawerName): void {
    const drawer = this._zuperDrawerService.getComponent(drawerName);
    drawer.toggle();
  }

  openAssignToRoute(job: any): void {
    this.currentSelectedJob = job;
    this.showAssignRoute = true;
    this.toggleDrawer('assignRoute');
  }

  assignRouteDrawerOpen(event): void{
    if(!event){
      this.showAssignRoute = false;
    }
  }

  toggleRouteLockState(): void {
    const isRouteLocked = this.currentRoute?.is_locked;
    const routeUid = this.currentRoute?.route_uid;
    let lockToggleConfirmationDialogRef: MatDialogRef<any>;
    if(isRouteLocked) {
      lockToggleConfirmationDialogRef = this._dispatchBoardService.routeDetailsChangeConfirmationDialog(this.currentRoute, 'unlockRoute');
    }
    else {
      lockToggleConfirmationDialogRef = this._dispatchBoardService.routeDetailsChangeConfirmationDialog(this.currentRoute, 'lockRoute');
    }
    lockToggleConfirmationDialogRef.afterClosed()
    .subscribe((result) => {
      if(result) {
        const lockUpdateToast = this._toast.loading(this.utilityService.getLocaleValue('route.lock.updating'));
        this._dispatchBoardService.updateRouteLock(routeUid, !isRouteLocked, (status: any) => {
          if(status) {
            lockUpdateToast.close();
            this.getRouteDetails(routeUid);
          }
          else{
            lockUpdateToast.close();
          }
        });
      }
    });
  }

  assignRoute(): void{
    const loader = this._toast.loading(this.utilityService.getLocaleValue('loader.reassign.jobs'));
    const routeSelected = this._jobsService.getSelectedRoute();
    this._dataCollectorService.postData(this._mapService.getRouteAssignUrl(this.currentRoute?.route_uid),{
      assign_route_users: true,
      job_uid: this.currentSelectedJob?.job_uid,
      route_uid: routeSelected?.route_uid
    }).subscribe((res: any) => {
      loader.close();
      this.getRouteDetails(routeSelected?.route_uid);
      if(res?.message){
        this._toast.success(res?.message);
        this.toggleDrawer('assignRoute');
      }
    },
    (err: any) => {
      loader.close();
      this.toggleDrawer('assignRoute');
    });
  }

  toggleJob(): void {
    this.jobPickerOptions.dataConfig = { ...this.jobPickerOptions.dataConfig, routeUid: this.currentRoute?.route_uid };
    this.openJob = true;
    this.jobPickerSubscription = this._datapickerService.onInit.subscribe(
      (res: any) => {
        this.openJob = false;
        const deletedJob = [];
        if(this.currentRoute?.jobs?.length)
        {
          this.currentRoute.jobs.forEach((job: any) => {
            const found = res?.find((selectedJob: any) => (selectedJob.job_uid === job.job?.job_uid));
            if(!found){
              deletedJob.push({
                'job_uid': job?.job?.job_uid
              });
            }
          });
        }
        const addedJob = [];
        if(res?.length)
        {
          res?.forEach((selectedJob: any) => {
            const found = this.currentRoute?.jobs?.find((job: any) => (selectedJob.job_uid === job.job?.job_uid));
            if(!found){
              addedJob.push({
                'job_uid': selectedJob?.job_uid,
                'geo_cords': selectedJob?.customer_address?.geo_cordinates
              });
            }
          });
        }
        if(addedJob.length && deletedJob?.length){
          this.addJobs(addedJob, deletedJob);
        }else if(addedJob.length){
          this.addJobs(addedJob);
        }else if(deletedJob.length){
          this.removeJobs(deletedJob);
        }
      }
    );
  }

  addJobs(addedJobs: any, deletedJob?: any): void {
    const loader = this._toast.loading(this.utilityService.getLocaleValue('loader.jobs.update'));

    this._dataCollectorService.postData(this._mapService.addJobsUrl(this.currentRoute?.route_uid),{
      'jobs': addedJobs
    })
    .subscribe((res: any) => {
      loader.close();
      if(deletedJob?.length){
        this.removeJobs(deletedJob);

      }else if(res?.message){
        this._toast.success(res?.message);
        this.getRouteDetails(this.currentRoute?.route_uid);
      }
    },
    (err: any) => {
      loader.close();

    });
  }

  removeJobs(deletedJob: any): void {
    const loader = this._toast.loading(this.utilityService.getLocaleValue('loader.jobs.update'));
    this._dataCollectorService.deleteDataPayload(this._mapService.mapsAPi.getRoutes+'/'+this.currentRoute?.route_uid+'/job',{
      jobs: deletedJob,
      unassign_users: false
    })
    .subscribe((res: any) => {
      loader.close();
      if(res?.message){
        this._toast.success(res?.message);
        this.getRouteDetails(this.currentRoute?.route_uid);
      }
    },
    (err: any) => {
      loader.close();

    });
  }

  getPickerFilter(): any {
    let jobs = [];
    if(this.currentRoute?.jobs?.length){
      jobs = this.currentRoute?.jobs?.map((job: any) => job?.job);
    }
    return [...jobs];
  }

  dataPickerEventHandler(event: any): void {
    if (event.drawerClosed) {
      this.openJob = false;
      if(this.jobPickerSubscription?.unsubscribe){
        this.jobPickerSubscription.unsubscribe();
      }
    }
  }

  drawerOpenedChanged(event: any): void {
    this.openPicker = event;
    if(!event){
      this.actionComplete.emit({
        data: this.currentRoute,
        status: 'close'
      });
    }
  }

  moveToJob(job: any): void {
    this.actionComplete.emit({
      data: job,
      status: 'view'
    });
  }

  moveToLocation(data: any): void {
    if(data?.geo_cords?.length){
      const location = {
        latitude: data?.geo_cords[0],
        longitude: data?.geo_cords[1]
      };
      this.actionComplete.emit({
        data: location,
        status: 'view'
      });
    }
  }

  setTabClasses(mode: string): any {
    return {
      'border-indigo-500 text-indigo-600': this.currentTab === mode,
      'border-transparent text-gray-500 hover:text-gray-700 hover:border-gray-200': this.currentTab !== mode
    };
  }

  closeDrawer(): void {
    const drawer = this._zuperDrawerService.getComponent('routeDetails');
    if(drawer){
      drawer.close();
    }
  }

  getAssignedUsers(): any[] {
    return this.currentRoute.assigned_to?.map(value => value.user) || [];
  }

  toggleAssignmentDrawer(drawerName): void {
    this.assignEmployeeOptions = {...this.assignEmployeeOptions, submitButtonTitle: 'text.save', drawerTitle: this.utilityService.getLocaleValue('header.route_assignment','Route Assignment')};
    const drawer = this._zuperDrawerService.getComponent(drawerName);
    drawer.toggle();
    this.openEmployee = true;
  }

  toggleReorderDrawer(drawerName): void {
    const drawer = this._zuperDrawerService.getComponent(drawerName);
    drawer.toggle();
    this.openReorder = true;
  }

  closeReorderDrawer(): void {
    const drawer = this._zuperDrawerService.getComponent('reorderJobDrawer');
    if (drawer) {
      drawer.close();
    }
  }

  onReorderChange(event: any): void {
    this.jobs = [...event];
  }

  optimiseRoute(): void {
    const loader = this._toast.loading(this.utilityService.getLocaleValue('loader.route_optimise'));
    this._dataCollectorService.postData(this._mapService.getOptimiseUrl(this.currentRoute?.route_uid),{})
      .subscribe((res: any) => {
        loader.close();
        if(res?.message){
          this._toast.success(res?.message);
        }
        this.getRouteDetails(this.currentRoute?.route_uid);
      }, (err: any) => {
        loader.close();

      });
  }

  onAssignmentEventEmitted(event): void{
    const drawer = this._zuperDrawerService.getComponent('assignEmployeeDrawer');
    drawer.toggle();
    this.openEmployee = false;
    if(event !== 'close'){
      if(event?.assign?.length > 0){
        const loader = this._toast.loading(this.utilityService.getLocaleValue('content.route_being_updated'));
        this.employeeAssignment(event, loader, 'ASSIGN');
      }else if(event?.unassign?.length > 0){
        const loader = this._toast.loading(this.utilityService.getLocaleValue('content.route_being_updated'));
        this.employeeAssignment(event, loader, 'UNASSIGN');
      }
    }
  }

  removeFromRoute(job: any): void {
    let showCheckbox = false;
    if(this.currentRoute?.assigned_to?.length){
      showCheckbox = true;
    }
    const dialogRef = this._zuperDialogService.openCustom(RemoveJobComponent,{
      data: job,
      checkbox: showCheckbox
    });
    dialogRef.afterClosed().subscribe(
      (res: any) => {
        if(res){
          const loader = this._toast.loading(this.utilityService.getLocaleValue('content.route_being_updated'));
          this._dataCollectorService.deleteDataPayload(this._mapService.deleteJobUrl(this.currentRoute?.route_uid),{
            jobs: [{job_uid: job?.job_uid}],
            unassign_users: res?.unassign
          }).subscribe((response: any) => {
            loader.close();
            if(response?.message){
              this._toast.success(response?.message);
            }
            this.getRouteDetails(this.currentRoute?.route_uid);
          }, (err: any) => {
            loader.close();

          });
        }
      }
    );
  }

  deleteRoute(): void {
    const dialogRef = this._zuperDialogService.open({
      title:`${this.utilityService.getLocaleValue('text.delete_route','Delete Route')}`,
      message: `${this.utilityService.getLocaleValue('route.delete.confirmation_message')} ${this.currentRoute?.route_name} (${moment.utc(this.currentRoute.departure).format(this.dateFormat)})?`,
      type:'error',
      actions    : {
      confirm: {
          show : true,
          label: 'Ok',
          color: 'error',
          confirmDisplayKey:'text.delete_route',
      },
      cancel : {
              show : true,
              label: 'Cancel'
          }
      }
    });
    dialogRef.afterClosed().subscribe((res: any) => {
      if(res){
        const loader = this._toast.loading(this.utilityService.getLocaleValue('loader.delete.route'));
        this._dataCollectorService.deleteData(this._mapService.mapsAPi.getRoutes+'/'+ this.currentRoute?.route_uid)
          .subscribe((response: any) => {
            loader.close();
            this.actionComplete.emit({
              data: this.currentRoute,
              status: 'delete'
            });
            if(response?.message) {
              this._toast.success(response?.message);
            }else{
              this._toast.success(this.utilityService.getLocaleValue('loader.delete.route_success'));
            }
          }, (err: any) => {
            loader.close();

          });
      }
    });
  }

  employeeAssignment(event: any, loader: any, type: 'ASSIGN' | 'UNASSIGN', unassign?: boolean): void {
    const url = (type === 'ASSIGN') ? this._mapService.getAssignUrl(this.currentRoute.route_uid) : this._mapService.getUnAssignUrl(this.currentRoute.route_uid);
    let data;
    if(type === 'ASSIGN'){
      if(event?.assign){
        data = {
          'users': event?.assign?.map((ele: any) => ({
            'team_uid': ele?.team?.team_uid,
            'user_uid': ele?.user?.user_uid
          }))
        };
      }
    }else if(type === 'UNASSIGN') {
      if(event?.unassign){
        data = {
          'users': event?.unassign?.map((ele: any) => ({
            'team_uid': ele?.team?.team_uid,
            'user_uid': ele?.user?.user_uid
          })),
        };
        if(unassign){
          data['unassign_users'] = true;
        }
      }
    }

    this._dataCollectorService.postData(url, data).subscribe(
      (res: any) => {
      if(type === 'ASSIGN'){
        this.assignEmployeeOptions['details']['assigned_to'] = event?.assign;
        if(event?.unassign?.length > 0){
          this.employeeAssignment(event, loader, 'UNASSIGN');
        }else{
          loader.close();
          this.getRouteDetails(this.currentRoute?.route_uid);
        }
      } else {
        loader.close();
        this.getRouteDetails(this.currentRoute?.route_uid);
      }
    }, (err: any) => {
      loader.close();

    });
  }

  toggleEditRoute(): void {
    this.routeEditFormOption = {
      state: 'edit',
      header: 'route.edit'
    };
    this.openForm = true;
  }

  toggleCloneRoute(): void {
    this.routeEditFormOption = {
      state: 'clone',
      header: 'text.clone_route'
    };
    this.openForm = true;
  }

  onFormActionComplete(event: any): void {
    if(event?.completed){
      this.getRouteDetails(event?.uid || this.currentRoute?.route_uid, event?.state);
    }else{
      this.openForm = false;
      this.currentRoute = {...this.currentRoute};
      this.sequencedJobs = this.getSequencedJobs(this.currentRoute.jobs);
    }
  }

  getSequencedJobs(jobs: any): any[] {
    if (jobs?.length > 0) {
      return _.orderBy(jobs, 'sequence', 'asc');
    }
    return [];
  }

  updateReorderJobs(): void {
    const loader = this._toast.loading(this.utilityService.getLocaleValue('loader.reorder.jobs'));
    this._dataCollectorService.putData(this._mapService.mapsAPi.getRoutes+'/'+ this.currentRoute?.route_uid+'/reorder',{
      'jobs': this.jobs.map((job: any) => (
        {
          job_uid: job?.job_uid
        }
      ))
    }).subscribe((res: any) => {
      loader.close();
      if(res?.message){
        this._toast.success(res?.message);
      }
      this.getRouteDetails(this.currentRoute?.route_uid);
    }, (err: any) => {
      loader.close();

    });
  }

  getRouteDetails(routeUid: any, state?: string): void {
    this._dataCollectorService.getData(this._mapService.mapsAPi.getRoutes + '/' + routeUid)
      .subscribe((res: any) => {
        this.currentRoute = res?.data;
        this.currentRoute = {...this.currentRoute, routeStartAddress: this._dispatchBoardService.getAddressText(this.currentRoute?.start_location),
          routeEndAddress: this._dispatchBoardService.getAddressText(this.currentRoute?.end_location),
        }
        this.sequencedJobs = this.getSequencedJobs(this.currentRoute.jobs).map((job: any) => {
          return {  ...job, jobAddress: this._dispatchBoardService.getAddressText(job?.job?.customer_address || job?.customer_address) };
        });
        this.openForm = false;
        this.currentRouteDate = moment(this.currentRoute?.departure);
        this.showAssignRoute = false;
        this.data = null;
        const locationData = {
          state: 'details',
          data: [this.currentRoute]
        };
        if ( this.parentModule !== 'dispatch') {
          this._mapService.routeLocationData.next(locationData);
        }
        if(state === 'clone'){
          this.actionComplete.emit({
            data: this.currentRoute,
            status: 'clone'
          });
        }
        else if(state === 'init'){
          this.actionComplete.emit({
            data: this.currentRoute,
            status: 'change',
            onInit: true
          });
        }
        else{
          this.actionComplete.emit({
            data: this.currentRoute,
            status: 'change'
          });
        }
        this.closeReorderDrawer();
        this.jobs = this.sequencedJobs?.map((job: any) => ({...job.job, jobAddress: this._dispatchBoardService.getAddressText(job?.job?.customer_address || job?.customer_address) }));
        if(this.currentRoute?.assigned_to?.length){
          this.assignEmployeeOptions['details']['assigned_to'] = [...this.currentRoute?.assigned_to];
        }else{
          this.assignEmployeeOptions['details']['assigned_to'] = [];
        }
        if(this.currentRoute.jobs?.length){
          this.currentRoute.jobs.forEach((job) => {
            if (job?.job?.scheduled_duration) {
              this.totalJobDuration += job?.job?.scheduled_duration;
            }
          });
        }
      },(err: any) => {

      });
  }
  getTotalScheduledDurationHours(minutes: number): number{
    return Math.floor(minutes / 60);
  }

  sanitizeJobAddress(address: any[]): string {
    return _.compact(address).join(', ');
  }

  ngOnChanges(changes: SimpleChanges): void {
    if('openPicker' in changes){
      this.openPicker = changes.openPicker.currentValue;
      if(this.openPicker){
        this._zuperDrawerService.getComponent('routeDetails').open();
      }else{
        const drawer = this._zuperDrawerService.getComponent('routeDetails');
        if(drawer){
          drawer.close();
        }
      }
    }
    // if('data' in changes){
    //   const drawer = this._zuperDrawerService.getComponent('routeDetails')
    //   if(drawer && this.openPicker){
    //     drawer.open();
    //     this.currentTab = 'PRIMARY'
    //   }
    //   this.data = changes.data.currentValue;
    //   if(this.data){
    //     this.getRouteDetails(this.data);
    //   }
    // }
  }

  ngOnInit(): void {
    this.companyConfig = this._localStorageService.getLocalStorage('company_configuration_data');
    this.dateFormat = this.utilityService.dateFormat;
    this.dateTimeFormat = this.utilityService.dateTimeFormat;
    this.timezone = this.parentModule === 'dispatch' ? this._dispatchBoardService.selectedTimezone.ROUTES : this.utilityService.timeZone;
    if(this.data){
      this.getRouteDetails(this.data, 'init');
    }

  }

  ngOnDestroy(): void {
    if(this.jobPickerSubscription?.unsubscribe){
      this.jobPickerSubscription.unsubscribe();
    }
  }

}
